module.exports = __webpack_public_path__ + "img/fangchan_icon0.fdefe40f.png";